// Reaction time is the measurement, so it must never be derived from the wall
// clock: Date.now() can jump backwards under NTP correction, and a jump inside
// a session would corrupt every reaction time after it.
//
// One Date.now() anchor is taken at session start and paired with a
// performance.now() reading. Every epoch stamp is that anchor plus a monotonic
// delta. Date.now() is never called again during a session.
export function createTrialClock({ now = Date.now, perf } = {}) {
  const perfNow = perf || (() => performance.now());
  const epochAnchor = now();
  const perfAnchor = perfNow();

  return {
    perfNow,
    toEpoch(perfTime) {
      return Math.round(epochAnchor + (perfTime - perfAnchor));
    },
  };
}

// Stimulus onset must be stamped at paint, not at the moment we scheduled the
// render. One rAF fires before the paint that applies the state change; the
// second fires after it.
export function afterPaint(cb) {
  if (typeof requestAnimationFrame !== 'function') {
    cb();
    return;
  }
  requestAnimationFrame(() => requestAnimationFrame(cb));
}
